module.exports = __webpack_public_path__ + "img/icon-settings.239181fe.svg";